import {
  clearAnalyticsUser,
  setAnalyticsUser,
  setAnalyticsUserProperties
} from '@cw-elements/analytics-provider';
import { useEffect } from 'react';

import { useAuth } from '@/libs';

import { UNKNOWN_COUNTRY_CODE } from './constants';

/**
 * Sole owner of the analytics identity, app-wide. The analytics provider
 * applies it to Amplitude and Datadog RUM alike and gates it on the user's
 * cookie consent: while consent is not granted an anonymous per-tab id is
 * reported instead, and the attributes below are held rather than sent — they
 * are never attached to the anonymous identity.
 */
const AnalyticsUserIdentifier = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      clearAnalyticsUser();

      return;
    }

    setAnalyticsUser(user.id);
    setAnalyticsUserProperties({
      email: user.email,
      name: user.name,
      role: user.role,
      locale: user.locale,
      countryCode: user.country_code || UNKNOWN_COUNTRY_CODE,
      // job_title is optional on the user; user properties only accept
      // strings, so include the key only when it is present.
      ...(user.job_title ? { jobTitle: user.job_title } : {})
    });
  }, [user]);

  return null;
};

export default AnalyticsUserIdentifier;
